module.exports = __webpack_public_path__ + "img/melania.7e2406ec.png";